<template>
    <el-select v-model="checkedvalStr" filterable
               :placeholder="disabled?'':'--选择--'"
			   :class="{'ljjSelectdisabled':disabled}"
               :clearable="clearable"
               :disabled="disabled"
               :multiple="multiple"
               @change="changes"
               style="width:100%">
        <el-option
                v-if="!showcode && !codeAndName"
                v-for="(item,index) in optionLists"
                :key="index"
                :label="`${item.name}`"
                :value="item.code">
        </el-option>
        <el-option
                v-if="showcode && !codeAndName"
                v-for="(item,index) in optionLists"
                :key="index"
                :label="`[${item.code}]${item.name}`"
                :value="item.code">
        </el-option>
        <el-option
                v-if="codeAndName"
                v-for="(item,index) in optionLists"
                :key="index"
                :label="`${item.name}`"
                :value="item.code+':'+item.name">
        </el-option>

    </el-select>
</template>
<script>
    import ss from '../../api/SystemService'
    export default {
        data(){
            return {
                optionLists:[],
            }
        },
        created(){
            if(!this.category){
                return [];
            }
            ss.Dictservice.listMdmbycategory(this.category).then(rd=>{
                this.optionLists = rd;
            })
        },
        computed: {
            //监听父组件的数值变化
            checkedvalStr:{
                get(){//回调函数 当需要读取当前属性值是执行，根据相关数据计算并返回当前属性的值
                    var val =  this.v == '0'?'0':_.toString(this.v)
                    if(this.multiple){
                        if(_.isArray(val)){
                            return val;
                        }else if(val){
                            return _.split(val,",");
                        }
                    }else{
                        return val;
                    }
                },
                set(val){//监视当前属性值的变化，当属性值发生变化时执行，更新相关的属性数据
                    if(_.isArray(val)){
                        this.$emit("input", _.join(val,","));//向外部发送事件通知
                    }else{
                        this.$emit("input", val);//向外部发送事件通知
                    }
                }
            },
        },

        methods:{
            changes(v){
                if(this.multiple){
                    var obj = _.filter(this.optionLists,(o)=>{
                        return _.includes(v,o.code)
                    })
                    this.$emit('change',obj)
                }else{
                    var obj = _.find(this.optionLists,{code:v})
                    this.$emit('change',obj)
                }
            },
        },
        props: ["category","v","multiple","disabled","clearable","showcode","codeAndName"],
    }
</script>
<style>

</style>
